"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * @class
 * @classdesc All the methods in this class are needed to format the numbers.<br/>
 * ATTENTION! This is a SINGLETON CLASS so it should be accessed as common.NumberFormatter.[methodName]
 * @constructor
 * @param {*} height 
 * @param {*} width 
 */
function NumberFormatter(height, width) {
  console.log("Number formatter constructor set default locale to IT");
  this.defaultLocale = 'it-IT'; // In si decidesse di passare la singola funziona del formatter
  // in giro come parametro allora occore bindare la funzioni.
  // this.setDefaultLocale = this.setDefaultLocale.bind(this);
  // this.getDefaultLocale = this.getDefaultLocale.bind(this);
}
/**
 * Set the locale for the NumberFormatter
 * @param {String} locale Locale ex: 'it-IT'
 */


NumberFormatter.prototype.persetDefaultLocale = function (locale) {
  this.defaultLocale = locale;
  console.log("Number formatter set default locale to " + locale);
};
/**
 * Get the actual Locale in use<br/>
 * Initial default locale is 'it-IT'
 * @returns {locale} defaultLocale
 */


NumberFormatter.prototype.getDefaultLocale = function () {
  return this.defaultLocale;
};
/**
 * 
 * @param {*} n 
 * @param {*} width 
 * @param {*} z 
 */


NumberFormatter.prototype.pad = function (n, width, z) {
  z = z || '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
};
/**
 * Format the number in percent format with 2 decimals
 * @param {Number} number The number to be formatted
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.percent = function (number, locale, defValue) {
  if (number === null || number === undefined || isNaN(number)) return defValue || "";
  if (!locale) locale = this.getDefaultLocale();
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: '2',
    maximumFractionDigits: '2'
  }).format(number) + '%';
};
/**
 * Format the number in percent format with 3 decimals
 * @param {Number} number The number to be formatted
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.percent3Digit = function (number, locale, defValue) {
  if (number === null || number === undefined || isNaN(number)) return defValue || "";
  if (!locale) locale = this.getDefaultLocale();
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: '3',
    maximumFractionDigits: '3'
  }).format(number) + '%';
};
/**
 * Format the number in percent format with 4 decimals
 * @param {Number} number The number to be formatted
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.percent4Digit = function (number, locale, defValue) {
  if (number === null || number === undefined || isNaN(number)) return defValue || "";
  if (!locale) locale = this.getDefaultLocale();
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: '4',
    maximumFractionDigits: '4'
  }).format(number) + '%';
};
/**
 * Format the number in percent format with 0 decimals
 * @param {Number} number The number to be formatted
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.intPercent = function (number, locale, defValue) {
  if (number === null || number === undefined || isNaN(number)) return defValue || "";
  if (!locale) locale = this.getDefaultLocale();
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: '0',
    maximumFractionDigits: '0'
  }).format(number) + '%';
};
/**
 * Format the number with 2 decimals
 * @param {Number} number The number to be formatted
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.format = function (number, locale, defValue) {
  if (number === null || number === undefined || isNaN(number)) return defValue || ""; //console.log('[NumberFormatter] format locale: ' + locale);

  if (!locale) locale = this.getDefaultLocale();
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: '2',
    maximumFractionDigits: '2'
  }).format(number);
};
/**
 * Format the number with 3 decimals
 * @param {Number} number The number to be formatted
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.format3Digit = function (number, locale, defValue) {
  return this.formatWithDigits(number, 3, locale, defValue);
};
/**
 * Format the number with 4 decimals
 * @param {Number} number The number to be formatted
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.format4Digit = function (number, locale, defValue) {
  return this.formatWithDigits(number, 4, locale, defValue);
};
/**
 * Format the number with 5 decimals
 * @param {Number} number The number to be formatted
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.format5Digit = function (number, locale, defValue) {
  return this.formatWithDigits(number, 5, locale, defValue);
};
/**
 * Format the number with 6 decimals
 * @param {Number} number The number to be formatted
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.format6Digit = function (number, locale, defValue) {
  return this.formatWithDigits(number, 6, locale, defValue);
};
/**
 * Format the number with passed locale
 * @param {Number} number The number to be formatted
 * @param {Number} digits The number of decimal digits
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.formatWithDigits = function (number, digits, locale, defValue) {
  if (number === null || number === undefined || isNaN(number)) return defValue || "";

  if (typeof digits !== 'string') {
    if (isNaN(digits)) return defValue || "";
  } //console.log('[NumberFormatter] format locale: ' + locale);


  if (!locale) locale = this.getDefaultLocale();
  var dgs = '' + digits;
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: dgs,
    maximumFractionDigits: dgs
  }).format(number);
};
/**
 * Format the number with 0 decimals
 * @param {Number} number The number to be formatted
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.formatInt = function (number, locale, defValue) {
  if (number === null || number === undefined || isNaN(number)) return defValue || ""; //console.log('[NumberFormatter] format locale: ' + locale);

  if (!locale) locale = this.getDefaultLocale();
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: '0',
    maximumFractionDigits: '0'
  }).format(number);
};
/*    
    format(number, locale, isMasked) {
        if (isMasked) {
            return "************";
        }
        locale = "it-CH";
        return new Intl.NumberFormat(locale, { minimumFractionDigits: '2', maximumFractionDigits: '2' }).format(number)
    }*/

/**
 * Format the number with 4 decimals
 * @param {Number} number The number to be formatted
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.format4FractionDigits = function (number, locale, defValue) {
  if (number === null || number === undefined || isNaN(number)) return defValue || "";

  if (!locale) {
    locale = this.getDefaultLocale();
  }

  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: '4',
    maximumFractionDigits: '4'
  }).format(number);
};
/**
 * Format the number with passed locale
 * @param {Number} number The number to be formatted
 * @param {Number} digits The number of decimal digits
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.formatDigits = function (number, digits, locale, defValue) {
  if (number === null || number === undefined || isNaN(number)) return defValue || "";
  if (!locale) locale = this.getDefaultLocale();
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: '' + digits,
    maximumFractionDigits: '' + digits
  }).format(number);
};
/**
 * Default formatter for the currencies. With 2 decimal digits.
 * @param {Number} number The number to be formatted
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.formatCurrency = function (number) {
  return this.formatDigits(number, 2, undefined, '');
};
/**
 * Default formatter for the prices. With 4 decimal digits.
 * @param {Number} number The number to be formatted
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.formatPrice = function (number) {
  return this.formatDigits(number, 4, undefined, '');
};
/**
 * Default formatter for quantity. With 3 decimal digits.
 * @param {Number} number The number to be formatted
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.formatQuantity = function (number) {
  return this.formatDigits(number, 3, undefined, '');
};
/**
 * Default formatter for percentages. With 2 decimal digits.
 * @param {Number} number The number to be formatted
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.formatPercentage = function (number) {
  return this.formatDigits(number, 2, undefined, '');
}; //JAVA PATTERN DEL TIPO #,##0.00000

/**
 * Format like a java pattern.<br/>
 * Java pattern example: #,##0.00000
 * @param {Number} number The number to be formatted
 * @param {String} javaPattern The pattern with witch it is intended to format
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.formatFromJavaPattern = function (number, javaPattern, locale, defValue) {
  if (!number || !javaPattern || typeof javaPattern !== 'string' || javaPattern.length <= 0) return defValue || "";
  var digits = 0;
  var zeroValueIndex = javaPattern.indexOf("0.");

  if (zeroValueIndex !== -1) {
    zeroValueIndex = zeroValueIndex + 2;
    var temp = javaPattern.substring(zeroValueIndex, javaPattern.length);

    if (temp && temp.length > 0) {
      digits = temp.length;
    }
  }

  if (digits > 0) {
    return this.formatWithDigits(number, digits, locale, defValue);
  }

  return number;
};
/* formatFractionDigits(number, locale, isMasked) {
     if (isMasked) {
         return "************";
     }
     locale = "it-CH";
     return new Intl.NumberFormat(locale, { minimumFractionDigits: '4', maximumFractionDigits: '4' }).format(number)
 }*/

/**
 * Calculates the biggest size possible for the value passed. And converts it in the biggest possible size: B/KB/MB/GB
 * @param {Number} value The size value of the file to be calculated
 * @param {String} defValue If the value passed is null or undefined this value is returned
 * @returns {String} The biggest possible value in the biggest possible size
 */


NumberFormatter.prototype.byteSize = function (value, defValue) {
  if (value === null || value === undefined || isNaN(value)) return defValue || "";
  var size; // KB 1024 
  // MB 1024 * 1024 = 1048576
  // GB 1024 * 1024 * 1024 =   1073741824

  size = value / 1073741824;

  if (size > 1) {
    return this.format(size) + " GB";
  }

  size = value / 1048576;

  if (size > 1) {
    return this.format(size) + " MB";
  }

  size = value / 1024;

  if (size > 1) {
    return this.format(size) + " KB";
  }

  return value + " B";
};

var _default = new NumberFormatter();

exports.default = _default;